import React, { useState } from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../Navbar/Navbar'
import Sidebar from '../Sidebar/Sidebar'

const Layout = () => {
    const [sidebar, setSidebar] = useState(false);

    const handleClick = () => {
        setSidebar(!sidebar);
    };
    //     style = { sidebar? { width: "0%", transition: "width .5s ease-in-out", } : { width: "24%", transition: "width .5s  ease-in-out" }
    // }

    return (
        <div className='flex'>
            <div className={`duration-200 transition-all sm:static sm:w-auto absolute top-0 left-0 z-[9999] h-full bg-gray-200/25 ${sidebar ? "w-full sm:w-[0] visible opacity-100 sm:opacity-0 sm:invisible  " : "w-[0%] opacity-0 sm:opacity-100 sm:w-[200px]  sm:visible invisible"}`}
            >
                <Sidebar sidebar={sidebar} handleClick={handleClick} />
            </div>
            <div style={{ width: "100%" }}>

                <Navbar handleClick={handleClick} />

                <div className='bg-light_bg min-h-[92vh] p-5'>
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default Layout;